export const ROUTES = {
    HOME: '/',
    CART: '/cart',
    PROFILE: '/profile',
    PRODUCT: '/products/:id',
    CATEGORIES: '/categories/:id',
}